import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";

import filterVolumsIcon from "../../../../Assets/img/icons/filter_volums.svg";
import { getGetAssetListingStatisticsThunk } from "../../../../Thunks";
import { KPIDrawer } from "./KPIDrawer";
import { ModalKpi } from "./ModalKpi";
import styles from "../statistics.module.css";

export function KPIChanges({ kpiChangesInTheLast30Days }) {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedChange, setSelectedChange] = useState(null);

  const [modalFilters, setModalFilters] = useState({
    enteredValue: "",
    negativeChange: false,
    positiveChange: false,
    selectedFields: [],
  });

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (search.trim() !== "") {
        dispatch(getGetAssetListingStatisticsThunk({ searchValue: search }));
      } else {
        dispatch(getGetAssetListingStatisticsThunk());
      }
    }, 400);

    return () => clearTimeout(delayDebounce);
  }, [search, dispatch]);

  const data = [
    {
      label: "Improvements",
      value: kpiChangesInTheLast30Days?.summary?.higher,
    },
    {
      label: "Regressions",
      value: kpiChangesInTheLast30Days?.summary?.lower,
    },
    {
      label: "Total Changes",
      value: kpiChangesInTheLast30Days?.summary?.total,
    },
  ];
  const KPI_FIELDS_MAP = {
    Maturity: "projectMaturityParameter",
    "Project Risk": "smartContractPlatformSecurityAuditLevel",
    "Historical Risk": "projectSecurityLevel",
    "AML Activities": "amlLevel",
    Lawsuits: "lawsuitsLevel",
  };

  const assetDatas =
    kpiChangesInTheLast30Days?.trends?.map((item) => {
      const changedParameters = Object.entries(KPI_FIELDS_MAP)
        .filter(([label, key]) => item[key] && item[key] !== null)
        .map(([label, key]) => ({
          label,
          value: item[key],
        }));
      return {
        id: item?.listingAsset?.id,
        asset: item?.listingAsset?.assetName,
        changedParameters,
      };
    }) || [];
  return (
    <div className={styles.statisticsContent}>
      <h2 className={styles.statisticsTitle}>
        KPI Changes in the last 180 days
      </h2>

      <div className={styles.statisticsColoredBar}>
        <div
          className={styles.statisticContent}
          style={{ justifyContent: "space-between", width: "80%" }}
        >
          {data.map((item, index) => (
            <div key={index} className={styles.statisticItem}>
              <p>{item.label}</p>
              <div className={styles.kpiValue}>
                <span>{item.value}</span>
              </div>
            </div>
          ))}
        </div>
        <div className={styles.divider}></div>
        <div
          className={styles.statisticTableWrapper}
          style={{ marginTop: "5px" }}
        >
          <div className={styles.statisticTableOneColumn}>
            <div
              className={styles.statisticTableWrapper}
              style={{
                marginBottom: "5px",
                marginTop: "20px",
              }}
            >
              <div className="listening_search_wrapper">
                <div className="listening_search_icon_wrapper"></div>
                <input
                  type="text"
                  className="listening_search_field"
                  placeholder="Search..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>
            <div
              className={styles.statisticTableContent}
              style={{
                marginBottom: "5px",
                paddingBottom: "1px",
                border: "none",
              }}
            >
              <div
                className="assetRowWrapper"
                style={{ color: "#889096", fontWeight: "600" }}
              >
                Asset
              </div>
              <div className="assetRowWrapper">
                <b>Parameters were changed</b>
                <div
                  className="listing_filter_volums_wrapper"
                  onClick={() => setIsModalOpen(true)}
                >
                  <img
                    src={filterVolumsIcon}
                    alt="filter volums"
                    className="listing_filter_volums"
                  />
                </div>
              </div>
            </div>
            {assetDatas.map((item, index) => (
              <div
                key={index}
                className={`${styles.statisticTableContent} ${styles.rowClickable}`}
                onClick={() => {
                  setSelectedChange({
                    id: item.id,
                    asset: item.asset,
                    allParameters: item.changedParameters,
                  });
                  setIsPopupOpen(true);
                }}
              >
                <div>{item.asset}</div>
                <div className={styles.score}>
                  {item.changedParameters.length > 0 ? (
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "25px",
                        alignItems: "center",
                      }}
                    >
                      {item.changedParameters.map((ch, i) => (
                        <div
                          key={i}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            width: "120px",
                          }}
                        >
                          <span
                            style={{ whiteSpace: "nowrap" }}
                          >{`${ch.label}`}</span>
                          {ch.value === "higher" && (
                            <span
                              className={styles.greenTriangle}
                              style={{ cursor: "pointer" }}
                              onClick={(e) => {
                                e.stopPropagation();
                                setSelectedChange({
                                  label: ch.label,
                                  value: ch.value,
                                  id: item.id,
                                  asset: item.asset,
                                });
                                setIsPopupOpen(true);
                              }}
                            ></span>
                          )}
                          {ch.value === "lower" && (
                            <span
                              className={styles.redTriangle}
                              style={{ cursor: "pointer" }}
                              onClick={(e) => {
                                e.stopPropagation();
                                setSelectedChange({
                                  label: ch.label,
                                  value: ch.value,
                                  id: item.id,
                                  asset: item.asset,
                                });
                                setIsPopupOpen(true);
                              }}
                            ></span>
                          )}
                          {ch.value === "same" && (
                            <span
                              className={styles.blueSquare}
                              style={{ cursor: "pointer" }}
                              onClick={(e) => {
                                e.stopPropagation();
                                setSelectedChange({
                                  label: ch.label,
                                  value: ch.value,
                                  id: item.id,
                                  asset: item.asset,
                                });
                                setIsPopupOpen(true);
                              }}
                            ></span>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    "-"
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {isModalOpen && (
        <ModalKpi
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          filters={modalFilters}
          setFilters={setModalFilters}
        />
      )}

      <KPIDrawer
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
        selectedChange={selectedChange}
      />
    </div>
  );
}
